import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class UserService {
  constructor(private readonly apollo: Apollo) {}

  async resetUserPassword(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.apollo
        .query({
          query: gql(`query GetResetUserPassword($id: Int!){
               getResetUserPassword(id: $id)
            }
          `),
          variables: { id },
        })
        .subscribe(response => {
          resolve(response['getResetUserPassword']);
        }, reject);
    });
  }

  async setUserPassword(id: number, password: string): Promise<boolean> {
    return firstValueFrom(
      this.apollo.query({
        query: gql(`query GetSetUserPassword($id: Int!, $password: String!){
               getSetUserPassword(id: $id, password: $password)
            }
          `),
        variables: { id, password },
      }),
    ).then(response => response['getSetUserPassword']);
  }
}
